<script setup lang="ts">
const header = ref<HTMLElement | null>(null)
const headerHeight = ref('auto')

useResizeObserver(header, (entries) => {
  const entry = entries[0]

  if (entry?.contentRect) {
    const { height } = entry.contentRect
    headerHeight.value = `${height}px`
  }
})
</script>

<template>
  <header
    ref="header"
    class="header"
  >
    <Html
      v-if="headerHeight !== 'auto'"
      :style="`--header-height: ${headerHeight};`"
    />
    <div
      ref="container"
      class="header__container"
    >
      <AppLogo
        class="header__logo"
        data-testid="logo"
      />

      <div class="header__entries">
        <AppMiniWishList />
        <CartMiniCart />
      </div>

      <AppSearch class="header__search" />

      <Navigation class="header__navigation" />
    </div>
  </header>
</template>

<style>
@import url("~layers/app/components/App/Header.css");
</style>
